export const LIST_MCU_PROJECT_PACKAGE_REQUEST = 'LIST_MCU_PROJECT_PACKAGE_REQUEST'
export const LIST_MCU_PROJECT_PACKAGE_SUCCESS = 'LIST_MCU_PROJECT_PACKAGE_SUCCESS'
export const LIST_MCU_PROJECT_PACKAGE_FAIL = 'LIST_MCU_PROJECT_PACKAGE_FAIL'

export const LIST_MCU_PROJECT_PACKAGE_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_PACKAGE_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_PACKAGE_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_PACKAGE_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_PACKAGE_SUMMARY_FAIL = 'LIST_MCU_PROJECT_PACKAGE_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_PACKAGE_REQUEST = 'CREATE_MCU_PROJECT_PACKAGE_REQUEST'
export const CREATE_MCU_PROJECT_PACKAGE_SUCCESS = 'CREATE_MCU_PROJECT_PACKAGE_SUCCESS'
export const CREATE_MCU_PROJECT_PACKAGE_FAIL = 'CREATE_MCU_PROJECT_PACKAGE_FAIL'

export const DETAIL_MCU_PROJECT_PACKAGE_REQUEST = 'DETAIL_MCU_PROJECT_PACKAGE_REQUEST'
export const DETAIL_MCU_PROJECT_PACKAGE_SUCCESS = 'DETAIL_MCU_PROJECT_PACKAGE_SUCCESS'
export const DETAIL_MCU_PROJECT_PACKAGE_FAIL = 'DETAIL_MCU_PROJECT_PACKAGE_FAIL'

export const UPDATE_MCU_PROJECT_PACKAGE_REQUEST = 'UPDATE_MCU_PROJECT_PACKAGE_REQUEST'
export const UPDATE_MCU_PROJECT_PACKAGE_SUCCESS = 'UPDATE_MCU_PROJECT_PACKAGE_SUCCESS'
export const UPDATE_MCU_PROJECT_PACKAGE_FAIL = 'UPDATE_MCU_PROJECT_PACKAGE_FAIL'

export const DELETE_MCU_PROJECT_PACKAGE_REQUEST = 'DELETE_MCU_PROJECT_PACKAGE_REQUEST'
export const DELETE_MCU_PROJECT_PACKAGE_SUCCESS = 'DELETE_MCU_PROJECT_PACKAGE_SUCCESS'
export const DELETE_MCU_PROJECT_PACKAGE_FAIL = 'DELETE_MCU_PROJECT_PACKAGE_FAIL'

export const LIST_PACKAGE_ADDITIONAL_INFO_REQUEST = 'LIST_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'LIST_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const LIST_PACKAGE_ADDITIONAL_INFO_FAIL = 'LIST_PACKAGE_ADDITIONAL_INFO_FAIL'

export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_REQUEST'
export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_SUCCESS'
export const LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL = 'LIST_SERVICE_ADDITIONAL_INFO_PACKAGE_FAIL'

export const CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'CREATE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'CREATE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const CREATE_PACKAGE_ADDITIONAL_INFO_FAIL = 'CREATE_PACKAGE_ADDITIONAL_INFO_FAIL'

export const DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST = 'DELETE_PACKAGE_ADDITIONAL_INFO_REQUEST'
export const DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS = 'DELETE_PACKAGE_ADDITIONAL_INFO_SUCCESS'
export const DELETE_PACKAGE_ADDITIONAL_INFO_FAIL = 'DELETE_PACKAGE_ADDITIONAL_INFO_FAIL'
export const RESET_MCU_PROJECT_PACKAGE = 'RESET_MCU_PROJECT_PACKAGE'

export const GET_MCU_PACKAGE_SUMMARIES_REQUEST = 'GET_MCU_PACKAGE_SUMMARIES_REQUEST'
export const GET_MCU_PACKAGE_SUMMARIES_SUCCESS = 'GET_MCU_PACKAGE_SUMMARIES_SUCCESS'
export const GET_MCU_PACKAGE_SUMMARIES_FAIL = 'GET_MCU_PACKAGE_SUMMARIES_FAIL'

export const GET_MCU_PACKAGE_SUPPORTING_DOCS_REQUEST = 'GET_MCU_PACKAGE_SUPPORTING_DOCS_REQUEST'
export const GET_MCU_PACKAGE_SUPPORTING_DOCS_SUCCESS = 'GET_MCU_PACKAGE_SUPPORTING_DOCS_SUCCESS'
export const GET_MCU_PACKAGE_SUPPORTING_DOCS_FAIL = 'GET_MCU_PACKAGE_SUPPORTING_DOCS_FAIL'
